import { URL } from "./_url";
import { PrintRequest } from "../types"
import { saveAs } from "file-saver";


const apiPrintPDF = (printRequest: PrintRequest) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', URL.PRINT_PDF(), true);
    xhr.responseType = 'arraybuffer';
    xhr.onload = function () {
        if (this.status === 200) {
            const type = xhr.getResponseHeader('Content-Type') || "application/pdf";
            const blob = createFileBlobInstance(this.response, printRequest.neighborhoodName, type);
            const URL1 = window.URL || window.webkitURL;
            const downloadUrl = URL1.createObjectURL(blob);
            saveAs(blob);
            window.open(
                downloadUrl,
                '_blank'
            );
        }
    };
    xhr.setRequestHeader('Content-type', 'application/json');
    xhr.send(JSON.stringify(printRequest));
}

const createFileBlobInstance = (response, neighborhoodName, type) => {
    let blob: any;
    const today = new Date();
    const date = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const year = today.getFullYear();
    if (typeof File === 'function') {
        try {
            blob = new File([response], `Drees Homes - ${neighborhoodName} home sites - ${month}-${date}-${year}.pdf`, { type: type });
        } catch (e) { / Edge / }
    }
    if (typeof blob === 'undefined') {
        blob = new Blob([response], { type: type });
    }
    return blob;
}

export { apiPrintPDF };
